import { useEffect } from 'react';

/**
 * Publish the height of the fixed banners above the page as a custom property.
 *
 * The banners are `position: fixed` and the layout pads the content column past them, so anything
 * outside that column — the assistant panel, mounted at the app root — has no other way to know
 * where the page actually starts. Set on the document element for the same reason
 * `assistant-panel-open` is: the readers aren't descendants of the layout.
 */
export const PAGE_BANNERS_HEIGHT_VAR = '--page-banners-height';

export function usePageBannersHeight(height: number): void {
  useEffect(() => {
    document.documentElement.style.setProperty(PAGE_BANNERS_HEIGHT_VAR, `${height}px`);
    return () => {
      document.documentElement.style.removeProperty(PAGE_BANNERS_HEIGHT_VAR);
    };
  }, [height]);
}
